import { Box, BoxProps, CircularProgress } from "@mui/material";

interface ProgressProps extends BoxProps {
  enabled: boolean;
}

export const Progress = (props: ProgressProps) => {
  if (!props.enabled) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        alignContent: "center",
        background: "rgba(0, 0, 0, 0.2)",
        ...props.sx,
      }}
    >
      <CircularProgress sx={{ m: "auto", display: "block" }} />
    </Box>
  );
};
